import { isEqualWith } from 'lodash';
import { baseFieldsMap } from '@/configs/fieldsMap.js';
import { LAND_LINE } from '@/components/Phone/const';
import { SHOP_STATUSINFO } from '@/configs/basicInfo';

const {
  SHOP_USETYPE_NORMAL,
  SHOP_STATUS_CLOSE,
  FAKE_SHOP_TYPE,
  GARBAGE_SHOP_TYPE,
} = SHOP_STATUSINFO;

//基本信息接口返回的字段，form表单的status和help红色字体展示
export function getValidtorStatusHelp(obj) {
  let { aiResult, editPoiInfo, isRequired, value, key } = obj;
  aiResult = aiResult || {};
  editPoiInfo = editPoiInfo || {};
  const { fieldKey, label, msg } = baseFieldsMap[key] || {};
  if (!fieldKey) return { status: '', help: '' };
  if (isRequired && !(value || editPoiInfo[key])) {
    return { status: 'error', help: msg || label + '必填项' };
  }
  if (aiResult.fieldMap && aiResult.fieldMap[fieldKey])
    return { status: 'error', help: aiResult.fieldMap[fieldKey] };
  return { status: '', help: '' };
}

// 营业状态报错页面
export function getMapStatus(power) {
  const { SHOP_STATUS_MAP } = SHOP_STATUSINFO;
  let openStatus;
  if (!power && power !== 0) return null;
  if (typeof power === 'string') {
    power = Number(power);
  }
  if (SHOP_STATUS_MAP.open.includes(power)) {
    openStatus = 5;
  } else if (SHOP_STATUS_MAP.prepare.includes(power)) {
    openStatus = 4;
  } else if (SHOP_STATUS_MAP.suspend.includes(power)) {
    openStatus = 2;
  } else if (SHOP_STATUS_MAP.close.includes(power)) {
    openStatus = 1;
  }
  return openStatus;
}

export const formatCateData = data => {
  if (!data) return [];
  data = data.map(item => {
    item.value = item.categoryId;
    item.label = item.needGray ? item.categoryName + '（暂不支持选择）' : item.categoryName;
    item.disabled = item.needGray;
    if (item.isLeaf) {
      item.children = null;
    } else {
      item.children = formatCateData(item.children);
    }
    return item;
  });
  return data;
};

// 根据线索referId和entrance查询poi数据，填充新增门店表单，表单数据和提交数据有有差异
export const getShopInfo = data => {
  // 线索查不到poi数据时，返回data为null或者{}
  if (data && Object.keys(data).length) {
    const payload = {};
    [
      'shopName',
      'branchName',
      'backCateList',
      'frontCatePath',
      'areaCode',
      'phoneList',
      'provinceId',
      'cityId',
      'cityName',
      'districtId',
      'districtName',
      'backCateList',
      'longitude',
      'latitude',
      'address',
      'groupId',
    ].forEach(item => {
      const value = data[item];
      // 只有有值才赋值覆盖默认值，没有值时不能赋值
      switch (item) {
        case 'backCateList':
          if (value && value.length) {
            payload.backCateId = (value.filter(item => item.isLeaf)[0] || {}).id;
            payload.backCateList = value;
          }
          break;
        case 'frontCatePath':
          if (value) {
            payload.frontCateName = value;
          }
          break;
        case 'phoneList':
          if (value && value.length) {
            payload.phoneList = value;
          }
          break;
        default:
          if (value) {
            payload[item] = value;
          }
          break;
      }
    });
    return payload;
  }
  return null;
};

export function getShopId(poiInfo = {}) {
  const key = poiInfo.dpShopId ? 'dpShopId' : poiInfo.mtShopId ? 'mtShopId' : null;
  const shopId = key && poiInfo[key];
  return { key, shopId };
}

// 判断字符串、数组是否为空
function isEmptyValue(val) {
  if (val === '' || val === null) return true;
  // 过滤掉数组中空值，例如['']
  if (Array.isArray(val)) {
    const newVal = val.filter(item => !!item);
    if (newVal.length === 0) return true;
  }
  return false;
}

export function isEqualCustomiza(oneObj, twoObj, customizer) {
  return isEqualWith(oneObj, twoObj, (objValue, othValue, key, ...restArgs) => {
    if (isEmptyValue(objValue) && isEmptyValue(othValue)) {
      return true;
    }
    if (customizer) return customizer(objValue, othValue, key, ...restArgs);
  });
}

export function getSceneInfo() {
  return {
    clientType: 1,
  };
}
export function getPhoneNumber(phoneList) {
  return (phoneList || []).map(
    phone =>
      `${phone.areaCode && phone.type === LAND_LINE ? `${phone.areaCode}-` : ''}${phone.entity ||
        ''}${phone.branch ? `-${phone.branch}` : ''}`
  );
}

// 将fromData标签状态数据同步到toData
export function shopTagsStateSync(fromData, toData) {
  // 标记toData是否被修改
  let isUpdated = false;
  const tempMap = {};
  fromData.commonList.map(item => {
    (item.tagList || []).map(tag => (tempMap[tag.tagId] = tag.selected));
  });
  fromData.systemGroup.writeList.map(tag => {
    tempMap[tag.tagId] = tag.selected;
  });
  toData.commonList.map(item => {
    (item.tagList || []).map(tag => {
      if (tempMap[tag.tagId] !== undefined) {
        // 标记是否被修改
        tag.selected !== tempMap[tag.tagId] && (isUpdated = true);
        tag.selected = tempMap[tag.tagId];
      }
    });
  });
  toData.systemGroup.writeList.map(tag => {
    if (tempMap[tag.tagId] !== undefined) {
      // 标记是否被修改
      tag.selected !== tempMap[tag.tagId] && (isUpdated = true);
      tag.selected = tempMap[tag.tagId];
    }
  });
  return isUpdated;
}

// 获取营业状态报错提交参数对象值
export function getPayloadForShopStatus(shopInfo, newStatus) {
  const { useType, power: originStatus, overseasFlag } = shopInfo;
  // 若点击了但未变更，使用原始值
  const power = newStatus === getMapStatus(originStatus) ? originStatus : newStatus;
  const params = {
    power,
    overseasFlag,
  };
  // 是否是垃圾虚假门店
  const isFakeShop = useType === FAKE_SHOP_TYPE || useType === GARBAGE_SHOP_TYPE;
  if (isFakeShop && newStatus !== SHOP_STATUS_CLOSE) {
    params.useType = SHOP_USETYPE_NORMAL;
  }
  return params;
}

// 将提交结果的错误信息设置到对应的表单字段项
// 结果字段map：fieldResultMap
export function setFieldErrorByResult(form, resultMap, form2ResultFieldMap) {
  const { getFieldsValue, setFields } = form;
  // 表单项字段map
  const formFieldMap = getFieldsValue();
  const fields = {};
  for (const key in formFieldMap) {
    if (Object.hasOwnProperty.call(formFieldMap, key)) {
      const resultKey = form2ResultFieldMap[key];
      if (resultMap[resultKey]) {
        fields[key] = {
          value: formFieldMap[key],
          errors: [new Error(resultMap[resultKey])],
        };
      }
    }
  }
  if (Object.keys(fields).length > 0) setFields(fields);
}

export function formValidatePromisify(form, { force = false } = {}) {
  return new Promise(resolve => {
    form.validateFieldsAndScroll({ force }, (err, value) => {
      console.log('err', err);
      resolve({ err, value });
    });
  });
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in km
};
